import React from 'react'
import { Field, WrappedFieldProps } from 'redux-form'
import { MaterialFieldProps } from '@cbgms/components/form/Material/MaterialField'
import { useRegisterTab } from '@cbgms/components/form/Tabs/TabItem'
import { CountryDropdownItem, CountrySelect } from '@carsys/form/src/CountriesDropdownBase'

export interface ReduxInputProps extends MaterialFieldProps<Omit<React.ComponentProps<typeof CountrySelect>, 'value'>> {
  form: string
}

const CountrySelectReduxWrapper = ({ input, onChange, ...rest }: ReduxInputProps & WrappedFieldProps) => {
  const handleOnchange = (e: React.ChangeEvent<{}>, value: CountryDropdownItem | null) => {
    input.onChange(value?.value)
    onChange && onChange(e)
  }

  return <CountrySelect onChange={handleOnchange} value={input.value} {...rest} />
}

export const CountrySelectReduxDropdown: React.FC<ReduxInputProps> = props => {
  useRegisterTab(props.name)

  const { name, validate, placeholder, onChange, form, ...rest } = props
  return (
    <Field
      validate={validate ? [validate] : undefined}
      name={name}
      placeholder={placeholder}
      component={CountrySelectReduxWrapper}
      variant='outlined'
      onChange={onChange}
      form={form}
      props={{ ...rest, name }}
    />
  )
}

export default CountrySelectReduxDropdown
